import { utils, writeFile } from 'xlsx'

const CreateXlsx = (templateName, headers, data) => {
  const xlsxData = data && data.length > 0 ? data : []

  /* create a new blank workbook */
  const wb = utils.book_new()
  const ws = utils.json_to_sheet(xlsxData, { header: [...headers] })
  utils.book_append_sheet(wb, ws, templateName)
  writeFile(wb, `${templateName}.xlsx`)
}

export { CreateXlsx }
